"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3388],{

/***/ 73388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "FromLibrary": function() { return /* reexport */ FromLibrary; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/Paragraph/ParagraphRenderer.tsx
var ParagraphRenderer = __webpack_require__(67025);
;// CONCATENATED MODULE: ./src/components/Paragraph/FromLibrary/FromLibrary.tsx


var FromLibrary = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ParagraphRenderer/* ParagraphRenderer */.W, {
        paragraphs: data.paragraph.content
    });
};

;// CONCATENATED MODULE: ./src/components/Paragraph/FromLibrary/index.ts



/***/ }),

/***/ 67025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ ParagraphRenderer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48641);
/* harmony import */ var _config_entity_mapping__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51285);





var getWrapper = function(name, Component) {
    if (name === "container") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
            maxW: "container.main",
            children: Component
        });
    } else if (name === "containerSmall") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
            maxW: "container.small",
            children: Component
        });
    }
    return Component;
};
var ParagraphRenderer = function(param) {
    var paragraphs = param.paragraphs, wrapperProps = param.wrapperProps, paragraphWrappers = param.paragraphWrappers, getWrapperForParagraph = param.getWrapperForParagraph;
    if (!paragraphs) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
        className: "paragraphs",
        children: paragraphs.map(function(paragraph, i) {
            var Component = _config_entity_mapping__WEBPACK_IMPORTED_MODULE_1__/* .EntityMapping */ .f[paragraph.__typename] || null;
            if (!Component) {
                console.warn("[ParagraphRenderer] Paragraph not found", paragraph.__typename);
                return null;
            }
            var InnerComponent = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
                data: paragraph
            });
            var OuterComponent = InnerComponent;
            if (paragraphWrappers) {
                if (paragraphWrappers[paragraph.__typename]) {
                    OuterComponent = getWrapper(paragraphWrappers[paragraph.__typename], InnerComponent);
                } else if (paragraphWrappers._all) {
                    OuterComponent = getWrapper(paragraphWrappers._all, InnerComponent);
                }
            }
            if (getWrapperForParagraph) {
                var wrapperName = getWrapperForParagraph(paragraph.__typename);
                if (wrapperName) {
                    OuterComponent = getWrapper(wrapperName, InnerComponent);
                }
            }
            if ("contentWidth" in paragraph) {
                if (paragraph.contentWidth === "small") {
                    OuterComponent = getWrapper("containerSmall", InnerComponent);
                }
            }
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                py: 3,
                className: paragraph.__typename,
                pos: "relative",
                __css: {
                    clear: "both"
                }
            }, wrapperProps), {
                children: OuterComponent
            }), "".concat(paragraph.id, "_").concat(i));
        })
    });
};


/***/ })

}]);